import '@css/app.css';

import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect';
import collapse from '@alpinejs/collapse';

Alpine.plugin(intersect);
Alpine.plugin(collapse);

// Main navigation: hover on desktop, tap-to-open accordion on mobile
const desktop = window.matchMedia('(min-width: 64rem)'); // Tailwind's lg breakpoint

Alpine.data('mainNav', () => ({
	mobileOpen: false,
	active: null,
	init() {
		desktop.addEventListener('change', () => this.close()); // reset when resizing across the breakpoint
	},
	hover(i) { if (desktop.matches) this.active = i; },
	toggle(i) { this.active = this.active === i ? null : i; },
	close() { this.active = null; this.mobileOpen = false; },
}));

window.Alpine = Alpine;
Alpine.start();


// USP band: auto-playing carousel below xl, static row from xl up
const uspCarousels = document.querySelectorAll('[data-usp-carousel]');
if (uspCarousels.length) {
	Promise.all([import('embla-carousel'), import('embla-carousel-autoplay')])
		.then(([{ default: EmblaCarousel }, { default: Autoplay }]) => {
			const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
			const plugins = reduceMotion ? [] : [Autoplay({ delay: 4000, stopOnInteraction: false, stopOnMouseEnter: true })];

			uspCarousels.forEach((el) => EmblaCarousel(el, {
				loop: true,
				align: 'start',
				breakpoints: { '(min-width: 64rem)': { active: false } }, // lg
			}, plugins));
		});
}

// Featured collections: looping, draggable carousel
const featuredCarousels = document.querySelectorAll('[data-featured-carousel]');
if (featuredCarousels.length) {
	import('embla-carousel').then(({ default: EmblaCarousel }) => {
		featuredCarousels.forEach((el) => EmblaCarousel(el, { loop: true, align: 'start' }));
	});
}

// Banners gallery: cross-fading slides, arrows, slide counter and progress bar.
// The progress bar's 6s CSS animation is the timer: when it finishes, the next slide fades in.
// Hovering or focusing the gallery pauses the animation (CSS), which pauses the slideshow too.
const bannerGalleries = document.querySelectorAll('[data-banner-gallery]');
const restartAnimation = (el) => {
	el.style.animation = 'none';
	void el.offsetWidth; // forces the browser to notice the change
	el.style.animation = '';
};
if (bannerGalleries.length) {
	Promise.all([import('embla-carousel'), import('embla-carousel-fade')])
		.then(([{ default: EmblaCarousel }, { default: Fade }]) => {
			bannerGalleries.forEach((root) => {
				const embla = EmblaCarousel(root.querySelector('[data-banner-viewport]'), { loop: true, duration: 30 }, [Fade()]);
				const progress = root.querySelector('[data-banner-progress]');
				const count = root.querySelector('[data-banner-count]');
				const total = embla.slideNodes().length;

				progress?.addEventListener('animationend', () => embla.scrollNext());

				const onSelect = () => {
					const index = embla.selectedScrollSnap();

					// Hidden slides can't be clicked or tabbed to
					embla.slideNodes().forEach((slide, i) => { slide.inert = i !== index; });

					if (count) count.textContent = `${index + 1} / ${total}`;

					// Restart the progress bar (and so the 6s timer) from zero
					if (progress) restartAnimation(progress);

					// Restart the Ken Burns zoom on the incoming slide. It's still at opacity 0 here, so the reset is invisible.
					embla.slideNodes()[index].querySelectorAll('.ken-burns').forEach(restartAnimation);
				};
				onSelect();
				embla.on('select', onSelect);

				root.querySelector('[data-banner-prev]')?.addEventListener('click', () => embla.scrollPrev());
				root.querySelector('[data-banner-next]')?.addEventListener('click', () => embla.scrollNext());
			});
		});
}
